exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alert-text-blink {\n    color: red;\n    font-weight: bolder;\n}\n\n.alert-btn-link {\n    padding: 0px !important;\n    min-width: 30px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/inline-alert/inline-alert.component.css
// module id = 835
// module chunks = 0